/**
 * Centralised legal entity information for Helios Brain.
 * Used by Imprint, Privacy Policy, Terms of Service pages and Footer.
 *
 * Source: ΓΕΜΗ registration.
 */

export const LEGAL = {
  // Legal entity
  legalName:        "HELIOS BRAIN SOCIETE ANONYME",
  legalNameGreek:   "ΗΛΙΟΣ ΜΠΡΕΪΝ ΑΝΩΝΥΜΗ ΕΤΑΙΡΕΙΑ",
  tradingName:      "Helios Brain",
  legalForm:        "Société Anonyme (S.A.)",
  legalFormGreek:   "Ανώνυμη Εταιρεία (Α.Ε.)",

  // Registration identifiers
  gemiNumber:       "190904001000",
  euid:             "ELGEMI.190904001000",
  vatNumber:        "EL803156468",
  vatNumberPlain:   "803156468",
  taxOffice:        "DOY Kifisias", // ΔΟΥ Κηφισιάς (best guess for the address)

  // Address
  street:           "Kifisias Avenue 265",
  streetGreek:      "Λεωφόρος Κηφισίας 265",
  city:             "Kifisia",
  cityGreek:        "Κηφισιά",
  region:           "North Athens · Attica",
  postalCode:       "14561",
  country:          "Greece",
  countryCode:      "GR",

  // Status
  incorporationDate:"30 January 2026",
  status:           "Active",

  // Contact
  emailGeneral:     "hello@heliosbrain.com",
  emailLegal:       "hello@heliosbrain.com",
  emailPrivacy:     "hello@heliosbrain.com",
  emailSecurity:    "hello@heliosbrain.com",
  emailResearch:    "research@heliosbrain.com",
  emailCareers:     "hello@heliosbrain.com",
  emailCompliance:  "hello@heliosbrain.com",

  // Web
  website:          "https://heliosbrain.com",

  // Last updates
  privacyUpdated:   "5 September 2026",
  termsUpdated:     "20 February 2026",
  imprintUpdated:   "20 February 2026",
};
